import * as React from "react";
const SvgBellFill = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M14.973 5.404a3 3 0 1 0-5.946 0A5 5 0 0 0 6 10v3q.001.514.1 1H6a2 2 0 1 0 0 4h2a4 4 0 0 0 8 0h2a2 2 0 0 0 0-4h-.1q.1-.486.1-1v-3c0-2.06-1.246-3.83-3.027-4.596M14 18a2 2 0 0 1-4 0z", clipRule: "evenodd" }));
export default SvgBellFill;
